module.exports = __webpack_public_path__ + "img/select_bg_center.81be8354.png";